import React from 'react';
import { motion } from 'framer-motion';

interface FeatureCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  delay?: number;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  icon,
  delay = 0,
}) => {
  return (
    <motion.div
      className="group relative h-full bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-500 border border-gray-100 hover:border-secondary-300/50 overflow-hidden"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
    >
      {/* Dekoratif Arka Plan Gradyanı (Hover'da belirir - çok hafif altın sarısı) */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-secondary-50/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

      <div className="relative z-10">
        {/* İkon Kutusu: Hover'da renkleri tersine çevirir */}
        <div className="w-14 h-14 rounded-2xl bg-primary-50 flex items-center justify-center text-primary-600 mb-6 transform group-hover:scale-110 group-hover:rotate-3 group-hover:bg-primary-600 group-hover:text-secondary-400 transition-all duration-500 shadow-sm">
          {/* İkonun boyutunu klonlayarak ayarlayabiliriz veya parent'tan gelen size'a güvenebiliriz. 
              Burada gelen ikonun boyutunu CSS ile kontrol etmek yerine saran div'i kontrol ediyoruz. */}
          <div className="w-7 h-7 flex items-center justify-center">
            {icon}
          </div>
        </div>
        
        {/* Başlık */}
        <h3 className="text-xl font-display font-bold text-gray-900 mb-3 group-hover:text-primary-800 transition-colors duration-300">
          {title}
        </h3>
        
        {/* Açıklama */}
        <p className="text-gray-600 leading-relaxed group-hover:text-gray-700">
          {description}
        </p>
      </div>

      {/* Dekoratif Alt Çizgi (Opsiyonel şıklık) */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-primary-600 to-secondary-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
    </motion.div>
  );
};

export default FeatureCard;